import { create_ssr_component, add_attribute } from "svelte/internal";
import Plotly from "plotly.js-dist-min";
import { createEventDispatcher, afterUpdate } from "svelte";
const PlotlyPlot = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let plot;
  let { value } = $$props;
  let { show_label } = $$props;
  let plot_div;
  let plotly_global_style;
  const dispatch = createEventDispatcher();
  function load_plotly_css() {
    if (!plotly_global_style) {
      plotly_global_style = document.getElementById("plotly.js-style-global");
      const plotly_style_clone = plotly_global_style.cloneNode();
      plot_div.appendChild(plotly_style_clone);
      for (const rule of plotly_global_style.sheet.cssRules) {
        plotly_style_clone.sheet.insertRule(rule.cssText);
      }
    }
  }
  afterUpdate(async () => {
    load_plotly_css();
    let plotObj = JSON.parse(plot);
    plotObj.config = plotObj.config || {};
    plotObj.config.responsive = true;
    plotObj.responsive = true;
    plotObj.layout.autosize = true;
    if (plotObj.layout.margin == void 0) {
      plotObj.layout.margin = {};
    }
    if (plotObj.layout.title && show_label) {
      plotObj.layout.margin.t = Math.max(100, plotObj.layout.margin.t || 0);
    }
    plotObj.layout.margin.autoexpand = true;
    Plotly.react(plot_div, plotObj.data, plotObj.layout, plotObj.config);
    Plotly.Plots.resize(plot_div);
    plot_div.on("plotly_afterplot", () => {
      dispatch("load");
    });
  });
  if ($$props.value === void 0 && $$bindings.value && value !== void 0)
    $$bindings.value(value);
  if ($$props.show_label === void 0 && $$bindings.show_label && show_label !== void 0)
    $$bindings.show_label(show_label);
  plot = value?.plot;
  return `<div${add_attribute("data-testid", "plotly", 0)}${add_attribute("this", plot_div, 0)}></div>`;
});
export {
  PlotlyPlot as default
};
